var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuBoxFilledBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M21.7991 8.63862C21.8215 8.71721 21.8215 8.793 21.8103 8.86879C21.8271 8.95862 21.8411 9.04845 21.8439 9.1495V20.6219C21.8439 21.5483 21.0259 22.3034 20.0175 22.3034H3.98401C2.97561 22.3034 2.15768 21.5483 2.15768 20.6219V9.1495C2.15768 8.98669 2.1885 8.8323 2.23612 8.68353C2.23752 8.67651 2.23752 8.6702 2.23752 8.66388C2.23752 8.65756 2.23752 8.65125 2.23892 8.64423L3.57224 3.89469C3.61986 3.15925 4.34255 2.57257 5.2249 2.57257H18.7739C19.6534 2.57257 20.3733 3.15644 20.4265 3.89189L21.7991 8.63862ZM18.9783 3.9761C18.9783 3.87785 18.8859 3.80206 18.7711 3.79925H14.1072L14.5694 7.46246H19.9671L19.0007 4.12207C18.9839 4.07435 18.9783 4.02663 18.9783 3.9761ZM5.01762 3.9761C5.01762 4.02382 5.01201 4.07154 4.99801 4.11926L4.05403 7.46527H9.09603L9.48258 3.80206H5.2221C5.11005 3.80206 5.01762 3.88066 5.01762 3.9761ZM20.0119 21.0654C20.2136 21.0654 20.3901 20.8549 20.3901 20.6163V9.14389C20.3901 8.90529 20.2136 8.69476 20.0119 8.69476H14.6506L14.6534 11.1622C14.6534 11.5018 14.3285 11.7769 13.9279 11.7769H9.74869C9.34813 11.7769 9.0232 11.5018 9.0232 11.1622V8.69476H3.9784C3.77672 8.69476 3.60306 8.90529 3.60306 9.14389V20.6163C3.60306 20.8549 3.77672 21.0654 3.9784 21.0654H20.0119Z",
    fill: "#650098"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuBoxFilledBlue);
export default __webpack_public_path__ + "static/media/ic-menu-box-filled-blue.bfbce34c5a98831173b99a764a7414ff.svg";
export { ForwardRef as ReactComponent };